function getEditorCoords(domRef, editor) {
  const nodeRect = domRef.$el.getBoundingClientRect();
  const viewRect = editor.view.area.el.getBoundingClientRect();
  const x = nodeRect.left - viewRect.left;
  const y = nodeRect.top - viewRect.top;
  const k = editor.view.area.transform.k;
  return [ x / k, y / k];
}

export default getEditorCoords;
